import { render } from "./App.vue?vue&type=template&id=6ff7c7a1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6ff7c7a1&lang=css"

import exportComponent from "C:\\Users\\15053\\Desktop\\Coding Docs\\Wizdom Project\\wisdom-v2\\wisdom-vue-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__